export default {
    accounting: "Бухгалтерия",
    action_log: "Аракеттер журналы",
    calendar: "Календарь",
    control: "Башкаруу",
    doctors: "Дарыгерлер",
    insurance: "Камсыздандыруучу",
    patients: "Бейтаптар",
    reports: "Отчеттор",
    services: "Кызматтар",
    settings: "Орнотуулар",
    users: "Колдонуучулар",
    warehouse: "Склад",
}
